import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setUser } from '@/redux/actions/userActions';
import { useFormik } from 'formik';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';
import fondo from '../style/_assets/img/fondo3.png';
import { signUp, loginExternal } from '@/services/authService';
import { useNavigate } from 'react-router-dom';
import emailjs from '@emailjs/browser';

const RegistrarModal = ({ open, onBack }) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      apellidoPaterno: '',
      apellidoMaterno: '',
      nombres: '',
      email: '',
      telefono: '',
      tipoDocumento: 'D.N.I.',
      documento: '',
      aceptaPoliticas: false,
      aceptaOfertas: false,
    },

    onSubmit: async (values) => {
      setErrorMessage('');
      setSuccessMessage('');

      // 🔹 Validaciones locales
      if (
        !values.apellidoPaterno ||
        !values.apellidoMaterno ||
        !values.nombres ||
        !values.email ||
        !values.telefono ||
        !values.documento
      ) {
        setErrorMessage('Complete todos los campos obligatorios');
        setTimeout(() => setErrorMessage(''), 3000);
        return;
      }

      if (!values.aceptaPoliticas) {
        setErrorMessage('Debe aceptar las políticas de privacidad para continuar.');
        setTimeout(() => setErrorMessage(''), 3000);
        return;
      }

      const payload = {
        name: values.nombres,
        email: values.email,
        password: values.documento,
        password_2: values.documento,
        dni: values.documento,
        celular: values.telefono,
        tipo: 'EXTERNO',
        paterno: values.apellidoPaterno,
        materno: values.apellidoMaterno,
        tipo_identidad: values.tipoDocumento,
        remember_me: values.aceptaPoliticas,
        sexo: 'INDEFINIDO',
      };

      try {
        setLoading(true);
        const response = await signUp(payload);
        if (!response?.success) throw new Error('Error al registrar');

        setSuccessMessage('Registro exitoso');

        const templateParams = {
          user_name: 'Usuario',
          reply_to: payload.email,
          copy_to: payload.email,
          message:
            'Estimado ' +
            payload.name +
            ' ' +
            payload.paterno +
            ', su cuenta en Dr. Q fué registrada correctamente, su usuario es: ' +
            payload.dni,
        };

        emailjs
          .send('service_zdu3k6p', 'template_3zc9p4j', templateParams, 'SuYqnE4z3_IEWAh90')
          .then(
            (response) => {
              console.log('ÉXITO!', response.status, response.text);
            },
            (err) => {
              console.log('FALLÓ...', err);
            },
          );

        try {
          const loginResp = await loginExternal(values.documento, values.documento, true);

          if (!loginResp?.access_token) {
            setErrorMessage('No se pudo iniciar sesión automáticamente');
            return;
          }

          console.log('viendo la respuesta: ', loginResp);

          const loggedUser = loginResp.user ?? loginResp.paciente ?? loginResp;

          localStorage.setItem('access_token', loginResp.access_token);
          localStorage.setItem('user', JSON.stringify(loggedUser));
          localStorage.setItem(
            'auth_data',
            JSON.stringify({
              paciente: loginResp.paciente,
              personal: loginResp.personal,
              token_type: loginResp.token_type,
              expires_at: loginResp.expires_at,
            }),
          );
          dispatch(setUser(loggedUser));

          formik.resetForm();
          setTimeout(() => {
            setSuccessMessage('');
            onBack();

            navigate('/paciente-datos');
          }, 1200);
        } catch (loginError) {
          console.error('Error login automático:', loginError);
          setErrorMessage('Error al iniciar sesión automáticamente');
        }
      } catch (error) {
        console.error('Error registro:', error);
        setErrorMessage(
          'No se pudo registrar el usuario, el correo o DNI ya se encuentran registrados en el sistema',
        );
        setTimeout(() => setErrorMessage(''), 4000);
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (open) {
      formik.resetForm();
      setErrorMessage('');
      setSuccessMessage('');
    }
  }, [open]);

  if (!open) return null;

  return (
    <FlexContainer
      className="pos-fixed justify-center align-items-center"
      style={{
        inset: 0,
        minHeight: '100vh',
        zIndex: 9999,
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: `url(${fondo})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: 'blur(5px)',
          zIndex: 1,
        }}
      />

      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.65)',
          zIndex: 2,
        }}
      />
      <form
        onSubmit={formik.handleSubmit}
        className="pos-rel bgBlue400-2"
        style={{
          borderRadius: '10px',
          padding: '26px',
          width: '360px',
          zIndex: 2,
          boxShadow: '0px 4px 20px rgba(0,0,0,0.25)',
          pointerEvents: loading ? 'none' : 'auto',
        }}
      >
        {/* LOGO */}
        <FlexContainer className="justify-center margb10">
          <img src="/Logotipo_Centro_Blanco2.png" alt="logo" style={{ width: '200px' }} />
        </FlexContainer>

        <Label className="text-center fontWhite text-16 margb4">Registrar Nuevo Usuario</Label>
        <Label className="text-center text-14 fontRed100 margb14">
          *Ingresar datos del paciente.
        </Label>

        {/* APELLIDOS */}
        <FlexContainer className="justify-between margb8" style={{ gap: 8 }}>
          <input
            type="text"
            name="apellidoPaterno"
            placeholder="1er Apellido"
            value={formik.values.apellidoPaterno}
            onChange={formik.handleChange}
            style={{
              width: '100%',
              border: '1px solid #D0D5DD',
              padding: '8px 8px',
              borderRadius: '6px',
            }}
          />
          <input
            type="text"
            name="apellidoMaterno"
            placeholder="2do Apellido"
            value={formik.values.apellidoMaterno}
            onChange={formik.handleChange}
            style={{
              width: '100%',
              border: '1px solid #D0D5DD',
              padding: '8px 8px',
              borderRadius: '6px',
            }}
          />
        </FlexContainer>

        <FlexContainer className="flex-column justify-between">
          <input
            type="text"
            name="nombres"
            placeholder="Nombres de paciente"
            value={formik.values.nombres}
            onChange={formik.handleChange}
            style={{
              maxWidth: '342px',
              border: '1px solid #D0D5DD',
              padding: '8px 8px',
              borderRadius: '6px',
              marginBottom: 8,
            }}
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formik.values.email}
            onChange={formik.handleChange}
            style={{
              border: '1px solid #D0D5DD',
              maxWidth: '342px',
              padding: '8px 8px',
              borderRadius: '6px',
              marginBottom: 8,
            }}
          />

          <input
            type="text"
            name="telefono"
            placeholder="Número de Teléfono"
            value={formik.values.telefono}
            onChange={formik.handleChange}
            maxLength={9}
            style={{
              border: '1px solid #D0D5DD',
              maxWidth: '342px',
              padding: '8px 8px',
              borderRadius: '6px',
              marginBottom: 8,
            }}
          />
        </FlexContainer>

        <FlexContainer className="justify-between margb12" style={{ gap: 8 }}>
          <select
            name="tipoDocumento"
            value={formik.values.tipoDocumento}
            onChange={formik.handleChange}
            style={{
              width: '100%',
              border: '1px solid #D0D5DD',
              padding: '8px 8px',
              borderRadius: '6px',
            }}
          >
            <option value="D.N.I.">D.N.I.</option>
            <option value="C.E.">C.E.</option>
            <option value="PASAPORTE">PASAPORTE</option>
          </select>

          <input
            type="text"
            name="documento"
            placeholder="N° de documento"
            value={formik.values.documento}
            onChange={formik.handleChange}
            maxLength={formik.values.tipoDocumento === 'D.N.I.' ? 8 : 9}
            style={{
              width: '100%',
              border: '1px solid #D0D5DD',
              padding: '8px 8px',
              borderRadius: '6px',
            }}
          />
        </FlexContainer>

        {/* CHECKS */}

        <FlexContainer className={'margt10 text-13 fontWhite'}>
          <input
            type="checkbox"
            name="aceptaPoliticas"
            className={'margr8'}
            checked={formik.values.aceptaPoliticas}
            onChange={formik.handleChange}
          />
          Acepto las
          <a
            href="/pdf/politicadeprivacidad.pdf"
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginLeft: 4 }}
          >
            {'políticas de privacidad de datos'}
          </a>
        </FlexContainer>

        <FlexContainer className={'margt10 text-13'}>
          <label className="text-12 margb12 fontWhite">
            <input
              type="checkbox"
              name="aceptaOfertas"
              checked={formik.values.aceptaOfertas}
              onChange={formik.handleChange}
            />{' '}
            Acepto recibir{' '}
            <a
              href="/pdf/Acep_ben_of_pu_nes_2025.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginLeft: 4 }}
            >
              ofertas, publicidad y novedades (Opcional)
            </a>
          </label>
        </FlexContainer>

        {loading && (
          <div
            style={{
              position: 'absolute',
              inset: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              background: 'rgba(255,255,255,0.7)',
              zIndex: 10,
              borderRadius: '10px',
            }}
          >
            <div className="spinner" />
          </div>
        )}

        {/* BOTONES */}
        <button
          type="submit"
          style={{
            width: '100%',
            background: '#ffffff',
            color: '#1E3A8A',
            padding: '10px',
            borderRadius: '18px',
            border: 'none',
            fontWeight: 600,
            marginBottom: 10,
            cursor: 'pointer',
          }}
        >
          REGISTRAR
        </button>

        <button
          type="button"
          onClick={onBack}
          style={{
            width: '100%',
            background: 'transparent',
            border: '2px solid white',
            color: 'white',
            padding: '10px',
            borderRadius: '18px',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          ← REGRESAR
        </button>
        {errorMessage && (
          <div
            style={{
              background: '#FFE5E5',
              color: '#C62828',
              padding: '8px 12px',
              borderRadius: '6px',
              fontSize: '13px',
              textAlign: 'center',
              marginBottom: '6px',
              marginTop: '12px',
              animation: 'fadeIn 0.3s ease-in-out',
            }}
          >
            {errorMessage}
          </div>
        )}
        {successMessage && (
          <div
            style={{
              background: '#E8F5E9',
              color: '#2E7D32',
              padding: '8px 12px',
              borderRadius: '6px',
              fontSize: '13px',
              textAlign: 'center',
              marginBottom: '6px',
              marginTop: '12px',
              animation: 'fadeIn 0.3s ease-in-out',
            }}
          >
            {successMessage}
          </div>
        )}
      </form>
    </FlexContainer>
  );
};

export default RegistrarModal;
